import { forwardRef, createElement } from 'react';

function IconPartnerApi(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M9.884 11.616a1.25 1.25 0 01.091 1.666l-.091.102-1.868 1.866H19a1.25 1.25 0 01.128 2.494L19 17.75H8.017l1.867 1.866a1.25 1.25 0 01-1.666 1.859l-.102-.091-4-4a1.26 1.26 0 01-.13-.152l-.068-.106-.042-.079-.046-.107-.03-.087-.03-.127-.016-.126-.004-.1.002-.08.013-.111.016-.088.03-.108.05-.127.086-.16.062-.088.064-.076 4.043-4.046a1.25 1.25 0 011.768 0zm5.898-9.091l.102.091 4 4c.03.03.058.061.084.094l-.084-.094c.048.048.09.099.13.152l.064.099.046.086.046.107.03.087.03.127.016.13.004.096-.002.08-.013.111-.016.088-.03.108-.05.127-.057.112-.069.106-.048.063-.081.089-4 4a1.25 1.25 0 01-1.859-1.666l.091-.102 1.866-1.866H5a1.25 1.25 0 01-.128-2.494L5 6.25h10.983l-1.867-1.866a1.25 1.25 0 011.666-1.859z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var PartnerApi = /*#__PURE__*/forwardRef(IconPartnerApi);

export default PartnerApi;
//# sourceMappingURL=PartnerApi.js.map
